import React from 'react';
import ReactDOM from 'react-dom';
import { toastr } from 'react-redux-toastr';
import EllipsisTooltip from './../../../../../common/EllipsisTooltip'
import { dispatch } from "@rematch/core";

function selectInputText(element) {
    element.setSelectionRange(0, element.value.length);
}

export default class InlineEdit extends React.Component {

    static defaultProps = {
        minLength: 1,
        maxLength: 128,
        editingElement: 'input',
        staticElement: 'span',
        tabIndex: 0,
        isDisabled: false,
        editing: false
    };

    state = {
        editing: this.props.editing,
        text: this.props.text,
        colorTag: this.props.colorTag,
        minLength: this.props.minLength,
        maxLength: this.props.maxLength,
    };

    componentWillMount() {
        this.isInputValid = this.props.validate || this.isInputValid;
        // Warn about deprecated elements
        if (this.props.element) {
            //console.warn('`element` prop is deprecated: instead pass editingElement or staticElement to InlineEdit component');
        }
    }

    componentWillReceiveProps(nextProps) {
        const isTextChanged = (nextProps.text !== this.props.text);
        const isColorChanged = (nextProps.colorTag !== this.props.colorTag);
        const isEditingChanged = (nextProps.editing !== this.props.editing);
        let nextState = {};
        if (isTextChanged) {
            nextState.text = nextProps.text;
        }
        if (isColorChanged) {
            nextState.colorTag = nextProps.colorTag;
        }
        if (isEditingChanged) {
            nextState.editing = nextProps.editing;
        }
        if (isTextChanged || isEditingChanged || isColorChanged) {
            this.setState(nextState);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        let inputElem = ReactDOM.findDOMNode(this.refs.input);
        if (this.state.editing && !prevState.editing && inputElem) {
            inputElem.focus();
            selectInputText(inputElem);
        } else if (this.state.editing && prevProps.text !== this.props.text) {
            this.finishEditing();
        }
    }

    startEditing = (e) => {
        if (this.props.stopPropagation) {
            e.stopPropagation()
        }
        this.setState({ editing: true, text: this.props.text });
    };

    finishEditing = () => {
        let elementType;
        if (this.props.elementType === 'communities') {
            elementType = 'Community';
        }
        else if (this.props.elementType === 'activities') {
            elementType = 'Activity';
        }
        if (this.isInputValid(this.state.text) && this.props.text !== this.state.text) {
            if (/^[^-\s][\s\S]{0,127}$/.test(this.state.text)) {
                this.commitEditing();
            } else {
                toastr.error('Message', 'Invalid ' + elementType + ' name.')
                this.cancelEditing();
            }
        } else if (this.props.text === this.state.text || !this.isInputValid(this.state.text)) {
            this.cancelEditing();

        }
        this.props.setEditModeFalse();
    };

    cancelEditing = () => {
        this.setState({ editing: false, text: this.props.text });
    };

    commitEditing = () => {
        this.setState({ editing: false, text: this.state.text });
        let newProp = {};
        newProp[this.props.paramName] = this.state.text;
        this.props.change(newProp, this.props.data);
    };

    doubleClickOnActivity = (e) => {
        dispatch.lifeCycle.showResourecePane(this.props.resourcPane);
        dispatch.lifeCycle.splitAt("60%");
        dispatch.app.setCollapsedResourcePaneIndexTemp(null);

    };

    isInputValid = (text) => {
        if (text.length > this.state.maxLength)
            toastr.error('Message', 'Maximum 128 characters allowed.')
        return (text.length >= this.state.minLength && text.length <= this.state.maxLength && this.props.validationFunction(text, this.props.data.id));
    };

    keyDown = (event) => {
        event.stopPropagation();
        if (event.keyCode === 13) {
            this.finishEditing();
        } else if (event.keyCode === 27) {
            this.cancelEditing();
        }

    };

    textChanged = (event) => {


        this.setState({
            text: event.target.value.trim()
        });
    };

    render() {
        if (this.props.status !== 0) {
            const Element = this.props.element || this.props.staticElement;
            return <Element
                className={this.props.className}
                style={this.props.style}
            // onDoubleClick={this.doubleClickOnActivity}
            >
                <EllipsisTooltip name={this.state.text || this.props.placeholder} />
            </Element>;
        } else {
            if (this.props.isDisabled) {
                const Element = this.props.element || this.props.staticElement;
                return <Element
                    className={this.props.className}
                    style={this.props.style} >
                    <EllipsisTooltip name={this.state.text || this.props.placeholder} />
                </Element>;
            } else if (!this.props.editing) {
                const Element = this.props.element || this.props.staticElement;
                return <Element
                    className={this.props.className}
                    // onDoubleClick={this.doubleClickOnActivity}
                    tabIndex={this.props.tabIndex}
                    style={this.props.style} >
                    <EllipsisTooltip name={this.state.text || this.props.placeholder} />
                </Element>;
            } else {
                const Element = this.props.element || this.props.editingElement;
                return <Element
                    onKeyDown={this.keyDown}
                    onBlur={this.finishEditing}
                    className={this.props.activeClassName}
                    placeholder={this.props.placeholder}
                    defaultValue={this.state.text}
                    onChange={this.textChanged}
                    style={this.props.style}
                    ref="input" />;
            }
        }

    }
}